import React, { Component } from 'react';
import {
  Button,
  Row,
  Col,
  Alert,
  Label,
  Input,
  FormGroup,
  InputGroupAddon,
  InputGroup
} from 'reactstrap';
import md5 from 'md5';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength } from '@src/validation';
import axiosInstance from '@src/axios-instance';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import moment from 'moment';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  agency_name: [value => maxLength(value, 255)],
  hash: [value => maxLength(value, 255)],
  email: [value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)],
  license_state: [value => maxLength(value, 64)],
  license_no: [value => maxLength(value, 64)],
  eoi_from: [],
  eoi_sender_name: [],
  eoi_subject: [],
  master_cert_eoi_subject: [],
  eoi_host: [],
  eoi_port: [],
  eoi_tls: [],
  eoi_password: [],
  qb_term_id: [],
  default_prepay: [],
  ringcentral_client_id: [],
  ringcentral_client_secret: [],
  ringcentral_client_secret_hash: [],
  ringcentral_api_url: [],
  ringcentral_user_name: [],
  ringcentral_password: [],
  ringcentral_extension: []
};

class TenantInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      loading: false,
      success: false,
      successSignature: false,
      signature: '',
      confirmModalActive: false
    };
  }

  openFilePicker = () => {
    this.fileUpload.click();
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  onFileSelect = e => {
    if (this.fileUpload.files.length > 0) {
      const formData = new FormData();
      formData.append('file', this.fileUpload.files[0]);

      axiosInstance()
        .post('/tenants/signature.json', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.setState({
            signature: response.data,
            successSignature:
              'Authorized Representative Signature has been updated.'
          });
        })
        .catch(err => {
          alert('Error');
        });
      this.fileUpload.value = '';
    }
  };

  onSignatureRemove = e => {
    axiosInstance()
      .get('/tenants/remove-signature.json')
      .then(response => {
        this.setState({
          signature: '',
          confirmModalActive: false,
          successSignature:
            'Authorized Representative Signature has been removed.'
        });
      })
      .catch(err => {});
  };

  getQBToken = () => {
    localStorage.setItem('qbRedirect', window.location.pathname);
    axiosInstance()
      .get('/tenants/get-qbtoken-url.json')
      .then(response => {
        window.location.href = response.data;
      });
  };

  componentDidMount = () => {
    axiosInstance()
      .get('/tenants/get-current.json')
      .then(response => {
        const fields = {};
        Object.keys(fieldValidator).forEach(key => {
          fields[key] = {
            value: response.data[key],
            visited: false,
            error: false
          };
        });

        this.setState({
          loaded: true,
          signature: response.data.signature,
          terms: response.data.terms,
          qbTokenValid:
            response.data.qb_refresh_token_expiry !== null
              ? moment(response.data.qb_refresh_token_expiry * 1000).format(
                  'MM/DD/YYYY HH:mm'
                )
              : null,
          ...fields
        });
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value: event.target !== undefined ? event.target.value : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    this.setState({
      success: false
    });
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value !== null && formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.setState({ loading: true });
      axiosInstance()
        .post('/tenants/save-current.json', postData)
        .then(response => {
          this.setState({
            success: 'Cool, your tenant information have been saved.'
          });
          window.scrollTo(0, 0);
          this.setState({ loading: false });
        });
    }
    return false;
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.loaded && (
          <div>
            {this.state.loading && (
              <ProgressBox text={'Loading ...'} loader={'blue-background'} />
            )}
            <Row>
              <Col xs={12} md={6}>
                {this.state.success !== false && (
                  <Alert color="success">{this.state.success}</Alert>
                )}
                <LabelInput
                  name={'Agency Name'}
                  type={'text'}
                  {...this.state.agency_name}
                  onChange={event => this.updateForm(event, 'agency_name')}
                />
                <label className={'font-weight-bold mb-1'}>Hash</label>
                <InputGroup className={'mb-3'}>
                  <Input
                    value={this.state.hash.value}
                    onChange={event => this.updateForm(event, 'hash')}
                  />
                  <InputGroupAddon addonType="append">
                    <Button
                      color="secondary"
                      onClick={() =>
                        this.setState(prevState => ({
                          hash: {
                            ...prevState.hash,
                            value: md5(
                              prevState.agency_name.value + new Date().getTime()
                            )
                              .substr(0, 32)
                              .toLowerCase()
                          }
                        }))
                      }
                    >
                      Regenerate
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            </Row>

            <p className={'d-flex align-items-center'}>
              {axiosInstance().defaults.baseURL +
                `cognito/index/${this.state.hash.value}`}
              <Button
                size={'sm'}
                color={'primary'}
                className={'ml-3'}
                onClick={() => {
                  navigator.clipboard.writeText(
                    axiosInstance().defaults.baseURL +
                      `cognito/index/${this.state.hash.value}`
                  );
                  setTimeout(() => {
                    alert('Link copied.');
                  }, 500);
                }}
              >
                Copy
              </Button>
            </p>
            <Row>
              <Col xs={12} md={6}>
                <LabelInput
                  name={'Email'}
                  type={'text'}
                  {...this.state.email}
                  onChange={event => this.updateForm(event, 'email')}
                />
                <LabelInput
                  name={'Phone'}
                  type={'text'}
                  {...this.state.phone}
                  onChange={event => this.updateForm(event, 'phone')}
                />
                <LabelInput
                  name={'Fax'}
                  type={'text'}
                  {...this.state.fax}
                  onChange={event => this.updateForm(event, 'fax')}
                />
                <LabelInput
                  name={'Address Line 1'}
                  type={'text'}
                  {...this.state.address_line_1}
                  onChange={event => this.updateForm(event, 'address_line_1')}
                />
                <LabelInput
                  name={'Address Line 2'}
                  type={'text'}
                  {...this.state.address_line_2}
                  onChange={event => this.updateForm(event, 'address_line_2')}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={3}>
                <LabelInput
                  name={'City'}
                  type={'text'}
                  {...this.state.city}
                  onChange={event => this.updateForm(event, 'city')}
                />
              </Col>
              <Col xs={12} md={3}>
                <LabelInput
                  name={'State'}
                  type={'text'}
                  {...this.state.state}
                  onChange={event => this.updateForm(event, 'state')}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <LabelInput
                  name={'Zip Code'}
                  type={'text'}
                  {...this.state.zip_code}
                  onChange={event => this.updateForm(event, 'zip_code')}
                />
                <LabelInput
                  name={'License State'}
                  type={'text'}
                  {...this.state.license_state}
                  onChange={event => this.updateForm(event, 'license_state')}
                />
                <LabelInput
                  name={'License #'}
                  type={'text'}
                  {...this.state.license_no}
                  onChange={event => this.updateForm(event, 'license_no')}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  color="primary"
                  className={'btn px-3'}
                  type={'submit'}
                  onClick={this.submitHandler}
                >
                  Save
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                <h3>
                  Signature
                  <Button
                    color={'secondary'}
                    className={'float-right'}
                    size={'sm'}
                    onClick={this.openFilePicker}
                  >
                    Upload New
                  </Button>
                  <input
                    ref={ref => (this.fileUpload = ref)}
                    type={'file'}
                    className={'d-none'}
                    onChange={this.onFileSelect}
                    accept={'.png,.jpg,.jpeg'}
                  />
                </h3>
                <p>Supported file formats: PNG, JPG/JPEG</p>
                <p>
                  <strong>Preview</strong>
                </p>
                <Row>
                  <Col xs={9}>
                    {this.state.successSignature !== false && (
                      <Alert color="success">
                        {this.state.successSignature}
                      </Alert>
                    )}
                    <div className={'border-bottom text-center'}>
                      {this.state.signature.length === 0 ? (
                        'NO SIGNATURE AVAILABLE'
                      ) : (
                        <img
                          alt={'Signature'}
                          className={'img-fluid'}
                          src={this.state.signature}
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs={3}>
                    {this.state.signature.length !== 0 && (
                      <Button
                        color={'danger'}
                        onClick={() => this.toggle('confirmModalActive')}
                      >
                        Remove
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col className={'pt-3'}>
                <h3>QuickBooks Integration </h3>
                <Button color={'primary'} onClick={this.getQBToken}>
                  Get QB Online Token
                </Button>
                <div>
                  {this.state.qbTokenValid !== null
                    ? `Valid till: ${this.state.qbTokenValid}`
                    : ''}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup check className={'pb-1 pt-2 mt-2 float-left mr-3'}>
                  <Label check>
                    <Input
                      style={{ top: '5px' }}
                      type="checkbox"
                      checked={this.state.default_prepay.value === 1}
                      onChange={event =>
                        this.updateForm(
                          event.currentTarget.checked ? 1 : 0,
                          'default_prepay'
                        )
                      }
                    />{' '}
                    Set EOI invoices as pre-pay by default.
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row className={'pt-2'}>
              <Col xs={12} md={6}>
                <div className={'form-group'}>
                  <label className={'font-weight-bold'}>QB Term</label>
                  <select
                    className={'form-control'}
                    value={this.state.qb_term_id.value}
                    options={this.state.terms}
                    onChange={event => this.updateForm(event, 'qb_term_id')}
                  >
                    {this.state.terms.map(term => {
                      return (
                        <option key={'term-' + term.id} value={term.id}>
                          {term.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  color="primary"
                  className={'btn px-3'}
                  type={'submit'}
                  onClick={this.submitHandler}
                >
                  Save
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col>
                <h3>EOI Email Sender</h3>
                <Row>
                  <Col xs={6}>
                    <LabelInput
                      name={'Sender Name'}
                      {...this.state.eoi_sender_name}
                      onChange={event =>
                        this.updateForm(event, 'eoi_sender_name')
                      }
                    />
                    <LabelInput
                      name={'EOI Subject'}
                      {...this.state.eoi_subject}
                      onChange={event => this.updateForm(event, 'eoi_subject')}
                    />
                    <LabelInput
                      name={'Master Cert EOI Subject'}
                      {...this.state.master_cert_eoi_subject}
                      onChange={event =>
                        this.updateForm(event, 'master_cert_eoi_subject')
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <LabelInput
                      name={'User Name'}
                      type={'email'}
                      {...this.state.eoi_from}
                      onChange={event => this.updateForm(event, 'eoi_from')}
                    />
                    <LabelInput
                      name={'Password'}
                      type={'password'}
                      {...this.state.eoi_password}
                      onChange={event => this.updateForm(event, 'eoi_password')}
                    />
                    <LabelInput
                      name={'Host'}
                      {...this.state.eoi_host}
                      onChange={event => this.updateForm(event, 'eoi_host')}
                    />
                    <LabelInput
                      name={'Port'}
                      {...this.state.eoi_port}
                      onChange={event => this.updateForm(event, 'eoi_port')}
                    />
                    <FormGroup
                      check
                      className={'pb-1 mt-1 mb-3 float-left mr-3'}
                    >
                      <Label check>
                        <Input
                          style={{ top: '5px' }}
                          type="checkbox"
                          checked={this.state.eoi_tls.value === 1}
                          onChange={event =>
                            this.updateForm(
                              event.currentTarget.checked ? 1 : 0,
                              'eoi_tls'
                            )
                          }
                        />{' '}
                        TLS Enabled
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      color="primary"
                      className={'btn px-3'}
                      type={'submit'}
                      onClick={this.submitHandler}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col>
                <h3>RingCentral Fax Integration</h3>
                <Row>
                  <Col xs={6}>
                    <LabelInput
                      name={'Client ID'}
                      {...this.state.ringcentral_client_id}
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_client_id')
                      }
                    />
                    <LabelInput
                      name={'Client Secret'}
                      type={'password'}
                      {...this.state.ringcentral_client_secret}
                      placeholder={
                        this.state.ringcentral_client_secret_hash !== undefined
                          ? this.state.ringcentral_client_secret_hash.value
                          : ''
                      }
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_client_secret')
                      }
                    />
                    <LabelInput
                      name={'API Url'}
                      {...this.state.ringcentral_api_url}
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_api_url')
                      }
                    />
                    <LabelInput
                      name={'User Name'}
                      {...this.state.ringcentral_user_name}
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_user_name')
                      }
                    />
                    <LabelInput
                      name={'Password'}
                      type={'password'}
                      {...this.state.ringcentral_password}
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_password')
                      }
                    />
                    <LabelInput
                      name={'Extension'}
                      {...this.state.ringcentral_extension}
                      onChange={event =>
                        this.updateForm(event, 'ringcentral_extension')
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      color="primary"
                      className={'btn px-3'}
                      type={'submit'}
                      onClick={this.submitHandler}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            <ConfirmModal
              isActive={this.state.confirmModalActive}
              toggle={() => this.toggle('confirmModalActive')}
              body={'Please confirm to delete this signature.'}
              confirmLabel={'Yes, delete this signature'}
              confirmAction={this.onSignatureRemove}
            />
          </div>
        )}
      </React.Fragment>
    );
  };
}
export default TenantInfo;
